<template>
  <div v-if="showContactUs">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3 class="welcome">Contact Us For Any Query</h3>
                </div>
              </div>
              <div class="modal-body">
                <h3>CALL: <a href="tel:+8801712-923209">+8801712-923209</a></h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ContactModal",
  data() {
    return {
    }
  },
  computed: {
    showContactUs() {
      return this.$store.state.showContactUs;
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('showContactUs',false);
    },
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-dialog {
  max-width: 500px !important;
}
.modal-header {
  border: none !important;
  margin-top: 10px;
}
.modal-body {
  padding: 0 30px;
}
.modal-body h3 {
  text-align: center;
  color: #8f2d56;
  margin-bottom: 30px;
  font-weight: bold;
}
.modal-body h3 > a {
  color: #8f2d56;
}
.welcome {
  text-align: center;
  font-weight: bold;
  color: #004a59;
  padding-bottom: 13px;
  border-bottom: 2px solid rgb(27, 118, 187,0.1);
}
.modal-header {
  display: block;
}
</style>